// TextAssets is styled separately so that it can be exported as a shared component.
export const textAssetsStyles = {
  deleteButton: {
    root: {
      height: 32,
      '& .ms-Button-label': {
        display: 'none',
      },
    },
  },
  newPositionDeleteButton: {
    root: {
      padding: 0,
      marginLeft: '5px !important',
      marginRight: '5px !important',
      height: 32,
      '& .ms-Button-label': {
        display: 'none',
      },
      '& img': {
        position: 'static !important',
      },
    },
  },
  newDeleteButton: {
    root: {
      marginLeft: '10px !important',
      marginRight: '5px !important',
      height: 32,
      '& .ms-Button-label': {
        display: 'none',
      },
    },
  },
  newPositionPinButton: {
    root: {
      height: 32,
      selectors: {
        '& .ms-Button-menuIcon': {
          display: 'none',
        },
        '& img': {
          position: 'static !important',
        },
        '& i': {
          display: 'flex',
          alignItems: 'center',
        },
      },
    },
  },
  newPinButton: {
    root: {
      height: 32,
      selectors: {
        '& .ms-Button-menuIcon': {
          display: 'none',
        },
        '& i': {
          display: 'flex',
          alignItems: 'center',
        },
      },
    },
  },
  pinButton: {
    root: {
      height: 32,
      selectors: {
        '& .ms-Button-menuIcon': {
          display: 'none',
        },
      },
    },
  },

  textAssetsStackToken: {
    childrenGap: 16,
  },
};
